/**
 * useContactOption — R6-Review F5
 *
 * Laedt EINEN Kontakt (GET /api/v2/contacts/{id}) nur fuer Select-Optionen.
 *
 * Hintergrund: Auswahllisten (z.B. das Payment-Formular) holen die Kontakte mit
 * `per_page=100` — mehr laesst das Backend nicht zu. Ist der einer Zahlung
 * zugeordnete Kontakt nicht unter diesen ersten 100, waere das <select> leer und
 * ein Speichern wuerde die Zuordnung stillschweigend entfernen. Dieser Hook holt
 * genau diesen einen Kontakt nach, damit er als Option ergaenzt werden kann.
 *
 * Der Request laeuft NUR wenn `enabled` gesetzt ist (also die Liste bereits
 * geladen ist und den Kontakt nachweislich nicht enthaelt).
 */
import { useApi } from '../../lib/use-api'
import apiClient from '../../lib/api-client'

export type ContactOption = {
  id: number
  name: string
}

type ContactOptionResponse = {
  data: ContactOption
}

export function useContactOption(
  contactId: number | null | undefined,
  enabled: boolean,
): ContactOption | undefined {
  const isEnabled = enabled && contactId != null

  const query = useApi<ContactOptionResponse>(
    ['contact-option', contactId],
    async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const client = apiClient as any
      const result = await client.GET('/api/v2/contacts/{id}', {
        params: { path: { id: String(contactId) } },
      })
      return result as { data?: ContactOptionResponse; error?: unknown }
    },
    {
      enabled: isEnabled,
      // Fehlt der Kontakt (404) oder ist er nicht lesbar, bleibt es beim
      // Roh-Fallback im Formular — kein Retry-Sturm.
      retry: false,
      staleTime: 5 * 60 * 1000,
    },
  )

  return query.data?.data
}
